import React from 'react';
import PropTypes from 'prop-types';
import Vehicle from './Vehicle';
import Driver from './Driver';
import { Header, Grid, Divider } from 'semantic-ui-react';
import moment from 'moment';
import numeral from 'numeral';

const PolicyInformation = ({ policy }) => {
	if (!policy.policyHolder) return null;
	
	return (
		<div className='information'>
			<Grid columns='equal' stackable>
				<Grid.Row>
					<Grid.Column>
						<Header as='h1' className='skinny' content={policy.nickname} />
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					<Grid.Column>
						<div className='field'>
							<Header as='h2' className='bold'>
								Policy#:
							</Header>
							<Header as='h2'>{policy.policyNumber}</Header>
						</div>
						<div className='field'>
						<Header as='h2'>Underwritten by {policy.companyName}</Header>
						</div>
					</Grid.Column>
					<Grid.Column>
						<div className='holder'>
							<Header as='h1' content={policy.policyHolder.displayName} />
							<Header as='h2' content={policy.policyHolder.address2 ? `${policy.policyHolder.address1}, ${policy.policyHolder.address2}` : policy.policyHolder.address1} />
							<Header as='h2' content={`${policy.policyHolder.city}, ${policy.policyHolder.state} ${policy.policyHolder.postalCode}`} />
						</div>
					</Grid.Column>
				</Grid.Row>
				<Divider />
				<Grid.Row>
					<Grid.Column>
						<Header as='h1' content='Payment Information' />
						{policy.billing.isPartOfAccountBill && (
							<div className='field'>
								<Header as='h2' className='bold'>
									Account:
								</Header>
								<Header as='h2'>{policy.billing.accountNumber}</Header>
							</div>
						)}

						<div className='field'>
							<Header as='h2' className='bold'>
								Plan:
							</Header>
							<Header as='h2'>{policy.paymentPlan}</Header>
						</div>
						<div className='field'>
							<Header as='h2' className='bold'>
								Auto Pay:
							</Header>
							<Header as='h2'>{policy.autoPay ? 'Yes' : 'No'}</Header>
						</div>
						<div className='field'>
							<Header as='h2' className='bold'>
								Term Premium:
							</Header>
							<Header as='h2'>{numeral(policy.termPremium).format('$ 0,0.00')}</Header>
						</div>
						<div className='field'>
							<Header as='h2' className='bold'>
								Current Outstanding Balance:
							</Header>
							<Header as='h2'>{numeral(policy.billing.isPartOfAccountBill ? policy.billing.accountOutstandingBalance : policy.outstandingBalance).format('$ 0,0.00')}</Header>
						</div>
						<div className='field'>
							<Header as='h2' className='bold'>
								Pay In Full:
							</Header>
							<Header as='h2'>{numeral(policy.billing.isPartOfAccountBill ? policy.billing.accountPayInFull : policy.payInFullAmount).format('$ 0,0.00')}</Header>
						</div>
						<div className='field'>
							<Header as='h2' className='bold'>
								Next Payment Due:
							</Header>
							<Header as='h2'>{policy.nextDueDate ? moment(policy.nextDueDate).format('MM/DD/YYYY') : ''}</Header>
						</div>
						<div className='field'>
							<Header as='h2' className='bold'>
								Amount Due:
							</Header>
							<Header as='h2'>{numeral(policy.nextDueAmount).format('$ 0,0.00')}</Header>
						</div>
					</Grid.Column>
				</Grid.Row>
				<Divider />
				{policy.vehicles ? (
					<Grid.Row>
						<Grid.Column id='vehicles'>
							<Header as='h1' content='Vehicles' />
							{policy.vehicles.map((v, i) => (
								<Vehicle key={i} vehicle={v} />
							))}
						</Grid.Column>
						<Grid.Column id='drivers'>
							<Header as='h1' content='Drivers' />
							{policy.drivers.map((d, i) => (
								<Driver key={i} driver={d} />
							))}
						</Grid.Column>
					</Grid.Row>
				) : null}
			</Grid>
		</div>
	);
};

PolicyInformation.propTypes = {
	policy: PropTypes.object.isRequired,
};

export default PolicyInformation;
